import React from 'react'
import { connect } from 'react-redux'
import Card, { TitleCard } from '../../core/Card'
import Line from '../../core/Line'
import { ForwardIcon, Icon, PlusIcon, MarkerIcon,
  SortIcon, AlphabeticalSortIcon, DateSortIcon
 } from '../../core/icons'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import { Slider, Select, Button, Col, Row, Popover, Icon as AIcon } from 'antd';
import New from './New'
import Update from './Update'
import EmptyState from '../../core/components/EmptyState'
import './Vehicles.css'

const vehicleLabel = (nickname, make, model) => {
  if (nickname) {
    return nickname
  }

  var name = make
  if (model) {
    name += " " + model
  }
  return name
}

const Vehicle = ({onClick, token_id, nickname, make, model, primary, icon_name}) =>
  <Line onClick={() => onClick(token_id)}>
      <Col span={2}
        style={{filter: 'hue-rotate(70deg) saturate(35%) opacity(90%) drop-shadow(1px 1px 1px lightgrey)'}}


        >
        <Icon type={icon_name || "Vehicle"}/>
      </Col>
      <Col span={12}>
        {vehicleLabel(nickname, make, model) }
      </Col>
      <Col span={8}>
        <span className="detail">{ primary && 'Primary'}</span>
      </Col>
      <Col span={1}>
        <ForwardIcon/>
      </Col>
  </Line>

const All = ({onClick, vehicles, pristine, disabled, loading, save, dispatch}) =>
  <div className="Vehicles">
    <TitleCard sticky>
      <h1>Vehicles</h1>
      <Link to="/account/vehicles/new">
        <Button type="primary" icon="plus" >
          New
        </Button>
      </Link>
    </TitleCard>

    <Card>
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Popover
          placement="bottomRight"
          content={
            <div>
              <a onClick={()=>dispatch({type:'SORT_VEHICLES', payload:'name'})}><AlphabeticalSortIcon/> Alphabetical</a>
              <hr/>
              <a onClick={()=>dispatch({type:'SORT_VEHICLES', payload:'date'})}><DateSortIcon/> Most Recent</a>
            </div>
          }
          // title="Sort by:"
          trigger="click"
        >
          <Button><SortIcon/> Sort</Button>
        </Popover>

      </div>
      { vehicles.map((props, i)=> <Vehicle key={i} onClick={onClick} {...props}/>)}
      {/* EMPTY STATE */}
      {vehicles.length<1 &&
        <EmptyState
          title="No Vehicles yet."
          buttonLink="/account/vehicles/new"
          buttonText="Add a Vehicle"
          buttonIcon='plus'
          icon={MarkerIcon}
        />
      }
    </Card>
  </div>

export default All



// WEBPACK FOOTER //
// ./src/account/vehicles/All.js